<div class="gallery-settings-container" *ngIf="gallery">
  <div class="gallery-settings-sidebar" *onlyForScreens="['desktop', 'tablet']">
    <div class="gallery-asset" *ngIf="gallery.teaser?.uuid" #el>
      <img [src]="gallery | galleryTeaserUrl : el.clientWidth" alt="" />
      <div class="remove-teaser dark">
        <button
          appButton
          name="remove-teaser"
          location="gallery-settings-dialog"
          color="hard-simple"
          height="1"
          shape="round"
          [iconButton]="true"
          (click)="removeTeaser()"
        >
          <app-svg src="/assets/icons/trash.svg"></app-svg>
        </button>
      </div>
    </div>
    <label class="gallery-asset empty" *ngIf="!gallery.teaser?.uuid" for="teaser-upload">
      <input
        type="file"
        id="teaser-upload"
        accept="image/*"
        class="hidden-input"
        (change)="uploadTeaserEvent($event.target)"
      />
      <app-svg src="/assets/icons/image-upload.svg"></app-svg>
    </label>

    <div class="sidebar-menu">
      <button
        appButton
        name="access"
        location="gallery-settings-dialog"
        location="gallery-settings-dialog"
        color="simple"
        [class.bc-simple-primary.constant]="mode === 'access'"
        (click)="mode = 'access'"
        [hasIcon]="true"
        shape="round"
        height="4"
        spacing="3"
        weight="bold"
        data-test-id="access"
      >
        <app-svg src="/assets/icons/gear.svg"></app-svg>
        <span>General</span>
      </button>
      <button
        appButton
        name="review"
        location="gallery-settings-dialog"
        color="simple"
        [class.bc-simple-primary.constant]="mode === 'review'"
        (click)="mode = 'review'"
        [hasIcon]="true"
        data-test-id="review"
        shape="round"
        height="4"
        spacing="3"
        weight="bold"
        appNewFeature="gallery-settings-review"
      >
        <app-svg src="/assets/icons/bolt.svg"></app-svg>
        <span>Review</span>
        <app-new-feature-dot featureName="gallery-settings-review" position="inline"></app-new-feature-dot>
      </button>

      <button
        appButton
        name="design"
        location="gallery-settings-dialog"
        color="simple"
        [class.bc-simple-primary.constant]="mode === 'design'"
        (click)="mode = 'design'"
        [hasIcon]="true"
        shape="round"
        height="4"
        spacing="3"
        weight="bold"
        data-test-id="design"
      >
        <app-svg src="/assets/icons/annotate-brush.svg"></app-svg>
        <span>Design</span>
      </button>

      <button
        appButton
        name="download"
        location="gallery-settings-dialog"
        color="simple"
        [class.bc-simple-primary.constant]="mode === 'download'"
        (click)="mode = 'download'"
        [hasIcon]="true"
        shape="round"
        height="4"
        spacing="3"
        weight="bold"
        data-test-id="download"
      >
        <app-svg src="/assets/icons/download.svg"></app-svg>
        <span>Download</span>
      </button>
    </div>

    <div class="presets" *ngIf="!galleryGuest">
      <app-context-menu name="presets" [options]="{ width: '280px', noSpacing: true }" #menu>
        <button
          appButton
          name="presets"
          location="gallery-settings-dialog"
          color="simple"
          [hasIcon]="true"
          height="2"
          spacing="2"
          contextButton
          appTooltip="Choose Gallery Preset"
          data-test-id="presets"
        >
          <app-svg src="/assets/icons/toggle.svg"></app-svg>
          <span>{{ currentPreset ? currentPreset.name : 'Custom' }}</span>
          <app-svg src="/assets/icons/12/chevron-down.svg" class="arrow-down"></app-svg>
        </button>
        <app-gallery-settings-presets-context
          contextContent
          [customPresets]="customPresets"
          [standardPresets]="standardPresets"
          [currentPreset]="currentPreset"
          [gallery]="gallery"
          (close)="menu.close()"
          (applyPreset)="applyPreset($event)"
          (createPreset)="createPreset()"
        ></app-gallery-settings-presets-context>
      </app-context-menu>
    </div>
  </div>

  <div class="gallery-settings-main-content">
    <div class="main-title-section">
      <ng-container *onlyForScreens="['desktop', 'tablet']">
        <h1 *ngIf="mode === 'access'">Gallery Settings</h1>
        <h1 *ngIf="mode === 'review'">Review & Feedback</h1>
        <h1 *ngIf="mode === 'download'">Download & Delivery</h1>
        <h1 *ngIf="mode === 'design'">Design</h1>
      </ng-container>
      <ng-container *onlyForScreens="['mobile']">
        <h1 *ngIf="mode === 'access'">Settings</h1>
        <h1 *ngIf="mode === 'review'">Review</h1>
        <h1 *ngIf="mode === 'download'">Download</h1>
        <h1 *ngIf="mode === 'design'">Design</h1>
      </ng-container>

      <button
        appButton
        name="share"
        location="gallery-settings-dialog"
        color="primary"
        weight="bold"
        spacing="4"
        height="4"
        size="3"
        shape="round"
        class="share-button"
        [hasIcon]="true"
        (click)="openShareDialog()"
      >
        <app-svg src="/assets/icons/forward.svg"></app-svg>
        <span>Share</span>
      </button>
    </div>

    <div class="settings-container">
      <ng-container *ngIf="mode === 'access'">
        <div *ngIf="publicAccessLevel === 'no_access'" class="full-warning" (click)="openShareDialog()">
          <app-svg src="/assets/icons/stop.svg"></app-svg>
          <span>Only people added can access</span>
        </div>

        <div [class.disabled-section]="gallery.public_access === 'no_access'">
          <div class="settings-box-group">
            <app-gallery-settings-item
              [gallery]="gallery"
              data-test-id="clientAdvancedMode"
              [item]="settingItems.access.clientAdvancedMode"
              [first]="true"
              [last]="true"
            >
            </app-gallery-settings-item>
          </div>

          <div class="settings-box-group">
            <app-gallery-settings-item
              [gallery]="gallery"
              [item]="settingItems.access.metadata"
              data-test-id="metadata"
              [first]="true"
            >
            </app-gallery-settings-item>
            <app-gallery-settings-item
              [gallery]="gallery"
              [item]="settingItems.access.versionHistory"
              data-test-id="versionHistory"
            >
            </app-gallery-settings-item>
            <app-action-box data-test-id="watermark">
              <app-action-box-icon [icon]="settingItems.access.watermarking.icon"></app-action-box-icon>
              <app-action-box-content
                [title]="settingItems.access.watermarking.title"
                [small]="true"
                [permission]="settingItems.access.watermarking.permission"
                [gallery]="gallery"
              >
                {{ settingItems.access.watermarking.description }}
              </app-action-box-content>
              <app-action-box-switch
                [switchValue]="$any(settingItems.access.watermarking.value)"
                (onSwitch)="setWatermarking($event)"
                [gallery]="gallery"
                [overridePermissionIfTrue]="true"
                [permission]="settingItems.access.watermarking.permission"
                [disabled]="isWatermarkApplying"
              >
              </app-action-box-switch>
              <div *ngIf="settingItems.access.watermarking.value" class="watermarking-box-content">
                <a
                  [routerLink]="'/a/settings/watermarks/create'"
                  *ngIf="!watermarks.length"
                  appButton
                  spacing="3"
                  name="create-watermark"
                  location="gallery-settings-dialog"
                  color="primary"
                  >Create Watermark</a
                >
                <div *ngIf="watermarks.length" class="watermarking-selector-container">
                  <app-context-menu [options]="{ noSpacing: true, width: '280px' }" #watermarksMenu>
                    <button
                      appButton
                      name="gallery-watermark"
                      location="gallery-settings-dialog"
                      [hasIcon]="true"
                      class="watermark-select-button"
                      [color]="!!selectedWatermark ? 'default' : 'gray-bordered'"
                      contextButton
                    >
                      <span>{{ selectedWatermark?.name || 'Choose' }}</span>
                      <app-svg src="/assets/icons/chevron-down.svg" color="gray"></app-svg>
                    </button>
                    <div contextContent class="button-menu">
                      <app-button-menu-item
                        name="select-watermark"
                        location="gallery-settings-dialog"
                        icon="image-watermarking"
                        *ngFor="let watermark of watermarks"
                        [color]="watermark === selectedWatermark ? 'simple-primary' : 'simple'"
                        [weight]="watermark === selectedWatermark ? 'bold' : 'normal'"
                        [fullWidth]="true"
                        (click)="selectedWatermark = watermark"
                        (onClick)="watermarksMenu.close()"
                      >
                        <span>{{ watermark.name }}</span>
                        <app-svg
                          src="/assets/icons/check.svg"
                          post
                          *ngIf="watermark === selectedWatermark"
                          class="some-check"
                        ></app-svg>
                      </app-button-menu-item>
                      <div class="divider"></div>
                      <app-button-menu-item
                        name="select-watermark"
                        location="gallery-settings-dialog"
                        icon="gear"
                        [color]="'simple'"
                        [fullWidth]="true"
                        [routerLink]="'/a/settings/watermarks'"
                      >
                        <span>Manage Watermarks</span>
                      </app-button-menu-item>
                    </div>
                  </app-context-menu>
                  <button
                    appButton
                    name="apply-watermark"
                    location="gallery-settings-dialog"
                    color="primary"
                    spacing="3"
                    (click)="applyWatermark(selectedWatermark)"
                    *ngIf="selectedWatermark && selectedWatermark.id !== gallery.watermark"
                    [class.disabled]="isWatermarkApplying"
                  >
                    Apply
                  </button>
                  <button
                    appButton
                    name="apply-watermark"
                    location="gallery-settings-dialog"
                    color="primary"
                    spacing="3"
                    (click)="refreshWatermark()"
                    *ngIf="selectedWatermark && selectedWatermark.id === gallery.watermark"
                    [class.disabled]="isWatermarkApplying"
                  >
                    Update
                  </button>
                </div>
                <div *ngIf="isWatermarkApplying" class="watermark-applying-message">
                  <app-loading-indicator [size]="'smaller'" [color]="'grey-50'"></app-loading-indicator>
                  <span>Applying watermarks.</span>
                </div>
              </div>
            </app-action-box>
            <app-gallery-settings-item
              [gallery]="gallery"
              [item]="settingItems.access.identifyVisitors"
              data-test-id="identifyVisitors"
              [last]="true"
            >
            </app-gallery-settings-item>
          </div>

          <div class="settings-box-group" *ngIf="!gallery.section">
            <app-gallery-settings-item
              [gallery]="gallery"
              [item]="settingItems.access.showInProfile"
              [first]="true"
              [last]="true"
            >
              <div class="gallery-link-container">
                Add this gallery to your
                <a href="https://{{ tenant?.path }}.picflow.com" target="_blank" class="primary-link gallery-link">
                  <span>Picflow Profile</span>
                  <app-svg src="/assets/icons/16/arrow-external.svg"></app-svg>
                </a>
              </div>
            </app-gallery-settings-item>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="mode === 'review'">
        <div class="settings-box-group">
          <app-gallery-settings-item
            [gallery]="gallery"
            [item]="settingItems.review.favourite"
            [first]="true"
            data-test-id="feedback-favourite"
          ></app-gallery-settings-item>
          <app-gallery-settings-item
            [gallery]="gallery"
            [item]="settingItems.review.flag"
            [last]="true"
            data-test-id="feedback-flag"
          >
          </app-gallery-settings-item>
        </div>

        <div class="settings-box-group">
          <app-gallery-settings-item
            [gallery]="gallery"
            [item]="settingItems.review.comment"
            [first]="true"
            data-test-id="feedback-comment"
          ></app-gallery-settings-item>
          <app-gallery-settings-item
            [gallery]="gallery"
            [item]="settingItems.review.annotation"
            data-test-id="feedback-annotation"
          >
          </app-gallery-settings-item>
          <app-gallery-settings-item
            [gallery]="gallery"
            [item]="settingItems.review.color_label"
            [last]="true"
            data-test-id="feedback-color_label"
          >
            <div class="custom-color-label-container" *ngIf="settingItems.review.color_label.value">
              <label class="custom-color-label-switch-parent" for="custom-color-labels">
                <div class="switch small" appTransitionPreventor>
                  <input
                    type="checkbox"
                    id="custom-color-labels"
                    [(ngModel)]="customColorLabels"
                    (ngModelChange)="onToggleCustomLabels()"
                    [disabled]="('!asset.customLabels' | permissions : gallery) && !customColorLabels"
                  />
                  <label for="custom-color-labels"></label>
                </div>
                <span
                  >Customize
                  <app-pro-tag
                    permission="asset.customLabels"
                    *ngIf="'!asset.customLabels' | permissions : gallery"
                    [tenantId]="gallery['tenant']?.['id'] || gallery['tenant']"
                  ></app-pro-tag>
                </span>
              </label>

              <form [formGroup]="customLabelsForm" class="show-errors-without-submitting" *ngIf="customColorLabels">
                <div *ngFor="let label of gallery.color_labels" class="custom-label">
                  <app-input-field [control]="customLabelsForm.controls[label.color]" class="headless" [noLabel]="true">
                    <div *appInputPre>
                      <app-svg src="/assets/icons/tag-filled.svg" [attr.color]="label.color" *ngIf="label.active">
                      </app-svg>
                      <app-svg src="/assets/icons/tag-dotted.svg" [attr.color]="label.color" *ngIf="!label.active">
                      </app-svg>
                    </div>
                    <input
                      type="text"
                      [formControlName]="label.color"
                      [attr.color]="label.color"
                      [class.disabled]="!label.active"
                      (input)="saveCustomLabels()"
                    />
                    <button
                      appButton
                      name="toggle-custom-labels"
                      location="gallery-settings-dialog"
                      [color]="label.active ? 'simple-primary' : 'simple-gray'"
                      *appInputPost
                      [iconButton]="true"
                      (click)="label.active = !label.active; saveCustomLabels()"
                    >
                      <app-svg src="/assets/icons/eye-open.svg" *ngIf="label.active"></app-svg>
                      <app-svg src="/assets/icons/eye-strikethrough.svg" *ngIf="!label.active"></app-svg>
                    </button>
                  </app-input-field>
                </div>
              </form>

              <div *ngIf="!customColorLabels" class="custom-labels-preview">
                <div *ngFor="let label of gallery.color_labels" class="color-{{ label.color }}">
                  <app-svg src="/assets/icons/tag-filled.svg"></app-svg>
                  <span>{{ label.name }}</span>
                </div>
              </div>
            </div>
          </app-gallery-settings-item>
        </div>
      </ng-container>

      <ng-container *ngIf="mode === 'design'">
        <div class="settings-box-group">
          <app-action-box data-test-id="gallery-background">
            <app-action-box-content
              [title]="settingItems.design.galleryBackground.title"
              [small]="true"
              [permission]="settingItems.design.galleryBackground.permission"
              [gallery]="gallery"
            >
              Color: {{ settingItems.design.galleryBackground.value || '#FFFFFF' }}
            </app-action-box-content>
            <div action-box-cta>
              <app-context-menu
                [options]="{ width: '282px', noSpacing: true }"
                #backgroundColorMenu
                [style.--gallery-background-color]="gallery.layout_background_color"
                [class.dark-background]="gallery.layout_background_color | isDarkColor"
              >
                <div class="background-selector" contextButton>
                  <div class="hoverlay"></div>
                  <app-svg src="/assets/icons/color-drop.svg"></app-svg>
                </div>

                <div contextContent class="color-picker-menu">
                  <app-color-selector
                    [(currentColor)]="gallery.layout_background_color"
                    (currentColorChange)="updateBackgroundColor($event)"
                    [gallery]="gallery"
                    [allowReset]="!!gallery.layout_background_color"
                    *ngIf="backgroundColorMenu.isOpen"
                  >
                  </app-color-selector>
                </div>
              </app-context-menu>
            </div>
          </app-action-box>
        </div>

        <div class="settings-box-group">
          <app-action-box>
            <app-action-box-content
              [title]="settingItems.design.titleFont.title"
              [small]="true"
              [permission]="settingItems.design.titleFont.permission"
              [gallery]="gallery"
            >
              Default Font: {{ gallery.default_title_typography.font_family || 'Picflow Type' }}
            </app-action-box-content>
            <div action-box-cta class="multi-button">
              <app-context-menu [options]="{ width: '264px', noSpacing: true }">
                <div
                  class="title-font-selector"
                  contextButton
                  [style.background-color]="gallery.layout_background_color"
                >
                  <span
                    [style.fontFamily]="gallery.default_title_typography.font_family + ', AkkuratLL'"
                    [style.color]="
                      gallery.default_title_typography.font_color ||
                      ((gallery.layout_background_color | isDarkColor) ? '#FFFFFF' : '#1f232e')
                    "
                    >Aa</span
                  >
                </div>

                <div contextContent>
                  <app-font-selection-menu
                    [currentFont]="gallery.default_title_typography.font_family"
                    (onSelected)="updateTitleFontFamily($event)"
                    [allowRemoveOverrides]="true"
                    (onRemoveoverrides)="onRemoveOverridesTitle()"
                  >
                  </app-font-selection-menu>
                </div>
              </app-context-menu>

              <app-context-menu
                [options]="{ width: '282px', noSpacing: true }"
                #titleColorMenu
                [style.--gallery-background-color]="
                  gallery.default_title_typography.font_color ||
                  ((gallery.layout_background_color | isDarkColor) ? '#FFFFFF' : '#1f232e')
                "
                [class.dark-background]="gallery.layout_background_color | isDarkColor"
              >
                <div class="background-selector" contextButton>
                  <div class="hoverlay"></div>
                </div>

                <div contextContent class="color-picker-menu">
                  <app-color-selector
                    [(currentColor)]="gallery.default_title_typography.font_color"
                    (currentColorChange)="updateTitleFontColor($event)"
                    [gallery]="gallery"
                    [allowReset]="!!gallery.default_title_typography.font_color"
                    *ngIf="titleColorMenu.isOpen"
                  >
                  </app-color-selector>
                </div>
              </app-context-menu>
            </div>
          </app-action-box>

          <app-action-box>
            <app-action-box-content
              [title]="settingItems.design.paragraphFont.title"
              [small]="true"
              [permission]="settingItems.design.paragraphFont.permission"
              [gallery]="gallery"
            >
              Default Font: {{ gallery.default_paragraph_typography.font_family || 'Picflow Type' }}
            </app-action-box-content>
            <div action-box-cta class="multi-button">
              <app-context-menu [options]="{ width: '264px', noSpacing: true }">
                <div
                  class="paragraph-font-selector"
                  [style.background-color]="gallery.layout_background_color"
                  contextButton
                >
                  <span
                    [style.fontFamily]="gallery.default_paragraph_typography.font_family + ', AkkuratLL'"
                    [style.color]="
                      gallery.default_paragraph_typography.font_color ||
                      ((gallery.layout_background_color | isDarkColor) ? '#FFFFFF' : '#5d6e82')
                    "
                    >Text</span
                  >
                </div>

                <div contextContent>
                  <app-font-selection-menu
                    [currentFont]="gallery.default_paragraph_typography.font_family"
                    (onSelected)="updateParagraphFontFamily($event)"
                    [allowRemoveOverrides]="true"
                    (onRemoveoverrides)="onRemoveOverridesParagraph()"
                  >
                  </app-font-selection-menu>
                </div>
              </app-context-menu>

              <app-context-menu
                [options]="{ width: '282px', noSpacing: true }"
                #paragraphColorMenu
                [style.--gallery-background-color]="
                  gallery.default_paragraph_typography.font_color ||
                  ((gallery.layout_background_color | isDarkColor) ? '#FFFFFF' : '#5d6e82')
                "
                [class.dark-background]="gallery.layout_background_color | isDarkColor"
              >
                <div class="background-selector" contextButton>
                  <div class="hoverlay"></div>
                </div>

                <div contextContent class="color-picker-menu">
                  <app-color-selector
                    [(currentColor)]="gallery.default_paragraph_typography.font_color"
                    (currentColorChange)="updateParagraphFontColor($event)"
                    [gallery]="gallery"
                    [allowReset]="!!gallery.default_paragraph_typography.font_color"
                    *ngIf="paragraphColorMenu.isOpen"
                  >
                  </app-color-selector>
                </div>
              </app-context-menu>
            </div>
          </app-action-box>
        </div>
      </ng-container>

      <ng-container *ngIf="mode === 'download'">
        <div class="settings-box-group">
          <app-gallery-settings-item
            [gallery]="gallery"
            [item]="settingItems.download.singleAsset"
            [first]="true"
            data-test-id="download-single"
          >
          </app-gallery-settings-item>
          <app-gallery-settings-item
            [gallery]="gallery"
            [item]="settingItems.download.fullGallery"
            [last]="false"
            data-test-id="download-gallery"
          >
          </app-gallery-settings-item>

          <app-action-box data-test-id="download-size" [disabled]="downloadSizeDisabled()">
            <app-action-box-icon [icon]="settingItems.download.downloadSize.icon"></app-action-box-icon>
            <app-action-box-content
              [title]="settingItems.download.downloadSize.title"
              [small]="true"
              [gallery]="gallery"
            >
              {{ settingItems.download.downloadSize.description }}

              <div *ngIf="gallery.watermark && enabledDownloadSizes.original" class="original-warning-message">
                <app-svg src="/assets/icons/16/alert.svg" size="-1"></app-svg>
                <span>To allow original downloads, you need to hide the watermark on selected assets.</span>
              </div>
            </app-action-box-content>
            <app-context-menu [options]="{ noSpacing: true, width: '280px' }" action-box-cta>
              <app-action-box-button contextButton name="max-download-size" location="gallery-settings-dialog">
                <button
                  appButton
                  name="max-download-size"
                  location="gallery-settings-dialog"
                  [hasIcon]="true"
                  class="download-size-button"
                >
                  <span>{{ downloadSizeString }}</span>
                  <app-svg src="/assets/icons/chevron-down.svg" color="gray"></app-svg>
                </button>
              </app-action-box-button>
              <div contextContent class="button-menu">
                <app-radio-button
                  *ngFor="let size of downloadSizes"
                  [checked]="enabledDownloadSizes[size.name]"
                  (click)="toggleDownloadSize(size.name)"
                  location="gallery-settings-dialog"
                >
                  <span class="standard-text">
                    <b>{{ size.name | capitalize }}</b>
                    <span *ngIf="size.size"> ({{ size.size }}px)</span>
                    <span *ngIf="!size.size"> (Source Files)</span>
                  </span>
                </app-radio-button>
              </div>
            </app-context-menu>
          </app-action-box>
        </div>
      </ng-container>

      <div class="feedback">
        <p>
          Do you have feedback or suggestions?
          <a class="primary-link" href="https://feedback.picflow.com/features" target="_blank">Contact us</a>
        </p>
      </div>
    </div>
  </div>
</div>

<app-sticky-footer [items]="menuItems" (onItemClick)="mode = $event.key" [selected]="mode" *onlyForScreens="['mobile']">
  <div class="mobile-presets" *ngIf="!galleryGuest">
    <app-context-menu name="presets" [options]="{ width: '280px', noSpacing: true }" #menu>
      <button
        appButton
        name="presets"
        location="gallery-settings-dialog"
        color="simple"
        [hasIcon]="true"
        height="2"
        size="1"
        spacing="0"
        contextButton
        appTooltip="Choose Gallery Preset"
        data-test-id="mobile-presets"
        [verticalIcon]="true"
      >
        <app-svg src="/assets/icons/toggle.svg"></app-svg>
        <div class="mobile-presets-button-text">
          <span>{{ currentPreset ? currentPreset.name : 'Custom' }}</span>
          <app-svg src="/assets/icons/12/chevron-down.svg" class="arrow-down"></app-svg>
        </div>
      </button>
      <app-gallery-settings-presets-context
        contextContent
        [customPresets]="customPresets"
        [standardPresets]="standardPresets"
        [currentPreset]="currentPreset"
        (onClose)="menu.close()"
        (applyPreset)="applyPreset($event)"
        (createPreset)="createPreset()"
      ></app-gallery-settings-presets-context>
    </app-context-menu>
  </div>
</app-sticky-footer>
